import { AdminDisplayState } from 'components/EmbeddedAdminWidget'
import { Host } from 'data/hosts/types'
import { isNil } from 'lodash'
import { getHostOrigin } from 'utilities/url'

const getMessageType = (isAdmin: boolean) =>
  isAdmin
    ? 'setAdminFrameHeight'
    : 'setFrameHeight'

export const getSendHeightFunction = (host?: Host, isAdmin = false) => {
  const sendHeight = (height: number) => {
    if (isNil(host)) {
      // console.log('No host')
      setTimeout(() => {
        sendHeight(height)
      }, 1000)
    } else {
      const origin = getHostOrigin(host)
      // console.log('send heighT', { height, host })
      height && window?.parent?.postMessage({
        blotter: {
          type: getMessageType(isAdmin),
          height,
          // height: isAdmin ? '1000px' : height,
        }
      }, origin)
    }
  }
  return sendHeight
}

// export const getSendAdminWidthFunction = (host?: Host) => {
//   const sendWidth = (width: number) => {
//     if (isNil(host)) {
//       setTimeout(() => {
//         sendWidth(width)
//       }, 1000)
//     } else {
//       const origin = getHostOrigin(host)
//       // console.log('Send width', { width, host })
//       width && window?.parent?.postMessage({
//         blotter: {
//           type: 'setAdminFrameWidth',
//           width,
//         }
//       }, origin)
//     }
//   }
//   return sendWidth
// }

export const sendAdminFrameToggle = (host?: Host, displayState?: AdminDisplayState) => {
  if (isNil(host)) {
    setTimeout(() => {
      sendAdminFrameToggle(host, displayState)
    }, 1000)
  } else {
    const origin = getHostOrigin(host)
    window?.parent?.postMessage({
      blotter: {
        type: 'setAdminFrameToggle',
        displayState,
      }
    }, origin)
  }
}
